import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PermissionGuard = ({ children, permission, anyOf }) => {
    const { user, checkPermission } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // `anyOf`: página multi-responsável (ex.: Configurações do Armazém, em que
    // cada aba tem permissão própria) — basta UMA das listadas.
    const denied = anyOf?.length
        ? !anyOf.some((key) => checkPermission(key))
        : permission && !checkPermission(permission);
    if (denied) {
        return (
            <div className="min-h-screen flex items-center justify-center p-4">
                <div className="bg-white dark:bg-mono-950 border border-mono-200 dark:border-mono-800 rounded-xl p-8 max-w-md text-center">
                    <div className="text-6xl mb-4">!</div>
                    <h2 className="text-2xl font-bold text-black dark:text-white mb-2">Acesso negado</h2>
                    <p className="text-mono-600 dark:text-mono-400">Voce nao tem permissao para acessar esta pagina.</p>
                </div>
            </div>
        );
    }

    return children;
};

export default PermissionGuard;
